import React, { createContext, useContext, useReducer } from 'react';
const AccordionStateContext = createContext(undefined);
const AccordionDispatchContext = createContext(undefined);
const accordionReducer = state => {
  return {
    ...state,
    open: !state.open
  };
};
export const AccordionProvider = ({
  open,
  shouldAnimate,
  shouldMapOpenPropToContent,
  children
}) => {
  const [state, dispatch] = useReducer(accordionReducer, {
    open,
    shouldAnimate,
    shouldMapOpenPropToContent
  });
  return React.createElement(AccordionStateContext.Provider, {
    value: state
  }, React.createElement(AccordionDispatchContext.Provider, {
    value: dispatch
  }, children));
};
export const useAccordionState = () => {
  const context = useContext(AccordionStateContext);
  if (context === undefined) {
    throw new Error('useAccordionState must be used within a AccordionProvider');
  }
  return context;
};
export const useAccordionDispatch = () => {
  const context = useContext(AccordionDispatchContext);
  if (context === undefined) {
    throw new Error('useAccordionDispatch must be used within a AccordionProvider');
  }
  return context;
};